export default "__VITE_ASSET__BwPMFsjm__"